import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavbarComponent } from './navbar/navbar.component';
import { MaterialModule } from './material/material.module';
import { HttpClientModule } from '@angular/common/http';
import { MainComponent } from './main/main.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { StatusPipe } from './pipes/status.pipe';
import { RolePipe } from './pipes/role.pipe';
import { DurationFromNowPipe } from './pipes/duration-from-now.pipe';
import { PersianNumberPipe } from './pipes/persian-number.pipe';
import { NgxEchartsModule } from 'ngx-echarts';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { LocationSelectorComponent } from './location-selector/location-selector.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxPaginationModule } from 'ngx-pagination';
import { TableComponent } from './table/table.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { EmptyComponent } from './empty/empty.component';
import { JalaliDatePipe } from './pipes/jalali-date.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { DragFileUploadDirective } from './pipes/drag-file-upload.directive';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { PorsantTypePipe } from './pipes/porsant-type.pipe';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SliderImageComponent } from './slider-image/slider-image.component';
import { AutoComplateClientComponent } from './auto-complete-client/auto-complate-client.component';
import { UploadPictureComponent } from './upload-picture/upload-picture.component';

@NgModule({
  declarations: [
    MainComponent,
    NavbarComponent,
    ConfirmDialogComponent,
    StatusPipe,
    RolePipe,
    DurationFromNowPipe,
    PersianNumberPipe,
    LocationSelectorComponent,
    TableComponent,
    PaginatorComponent,
    EmptyComponent,
    JalaliDatePipe,
    DragFileUploadDirective,
    UploadImageComponent,
    PorsantTypePipe,
    SliderImageComponent,
    AutoComplateClientComponent,
    UploadPictureComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxEchartsModule,
    CKEditorModule,
    LeafletModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxPaginationModule,
    SwiperModule
  ],
  exports: [
    MainComponent,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    StatusPipe,
    RolePipe,
    DurationFromNowPipe,
    PersianNumberPipe,
    NgxEchartsModule,
    CKEditorModule,
    NgxPaginationModule,
    TableComponent,
    PaginatorComponent,
    EmptyComponent,
    JalaliDatePipe,
    LeafletModule,
    NgxMaskModule,
    DragFileUploadDirective,
    UploadImageComponent,
    PorsantTypePipe,
    SwiperModule,
    SliderImageComponent,
    AutoComplateClientComponent,
    UploadPictureComponent
  ],
  entryComponents: [
    ConfirmDialogComponent,
  ]
})
export class SharedModule { }
